import React from 'react';
import CreditBundleOrderModal from 'components/billing/CreditBundleOrderModal';
import { SmsCreditBundle } from './SmsSettings';

interface SmsCreditOrderModalProps {
    bundles: SmsCreditBundle[];
    onOrderCompleted?: () => void;
}

// The sms credit bundle order modal, the shared bundle modal with the sms endpoints
const SmsCreditOrderModal: React.FC<SmsCreditOrderModalProps> = ({ bundles, onOrderCompleted }) => (
    <CreditBundleOrderModal
        bundles={bundles}
        orderApiUrl='post_sms_credit_order'
        returnPath='/settings/features/sms/thank-you'
        translationPrefix='sms.credits'
        onOrderCompleted={onOrderCompleted}
    />
);

export default SmsCreditOrderModal;
